import _ from 'lodash';
import qs from 'qs';

import {
  Firebase,
  FirebasePerformance,
  appConfig,
  scopeErrorReportingToUser,
  scopeFullstoryCaptureToUser,
  getCurrentTimestamp,
  accountId,
  organizationId,
  isProduction,
  isExport,
  omitDeleted,
  addKeysAsIds,
  unwrapDoc,
  unwrapDocs,
  actionPlanSetupForSprint,
  firstWeeklyReviewConductedForSprint,
  logAndDispatchErrorForAction,
  callIfFunction,
} from './../util';

import {
  AppConfigRef,
  OrgConfigRef,
  AssessmentConfigsRef,
  OrganizationsRef,
  OrganizationRef,
  UsersRef,
  PublicUsersRef,
  TeamsRef,
  CurrentSprintsRef,
  TalentEvaluationsRef,
  SalesCompetencyReviewsRef,
  LocalizationsRef,
  OrganizationExportsRef,

} from './../util/refs';

import {
  SYNC_APP_CONFIG,
  FETCH_ORG_CONFIG,
  FETCH_ASSESSMENT_CONFIG,
  SYNC_ASSESSMENT_CONFIGS,
  SYNC_USER,
  //FETCH_EMPLOYEE_DATA,
  LOGOUT,
  //TODO move these elsewhere
  SYNC_USERS,
  SYNC_ORGANIZATION,
  SYNC_EMPLOYEES,
  SYNC_TEAMS,
  SYNC_EXPORTS,

  FETCH_TEAMS,
  FETCH_TEAMS_SUCCESS,
  FETCH_TEAMS_ERROR,

  ACTIVATE_LOCALIZATION,
  ACTIVATE_LOCALIZATION_SUCCESS,
  ACTIVATE_LOCALIZATION_ERROR,


  //Assessments

  //For superadmins
  SYNC_ORGANIZATIONS,
  SYNC_LOCALIZATIONS,

} from './types';

// export function fetchEmployeeData(employeeId){
//   return dispatch => {
//     UsersRef().doc(employeeId).onSnapshot(doc => {
//       dispatch({
//         type: FETCH_EMPLOYEE_DATA,
//         payload: doc.data(),
//       });
//     });
//   }
// }

//For super admins
export function syncLocalizations(){
  return dispatch => {
    LocalizationsRef().onSnapshot(docs => {

      const localizations = unwrapDocs(docs);

      dispatch({
        type: SYNC_LOCALIZATIONS,
        payload: _.keyBy(localizations, '_id')
      });
    });
  }
}

export function activateLocalization(localizationKey = 'en', orgId = false, savePref = false, callback){

  // console.log('activateLocalization::');
  // console.log('localizationKey: ', localizationKey);
  // console.log('orgId: ', orgId);

  return dispatch => {

    dispatch({
      type: ACTIVATE_LOCALIZATION,
    });

    //Get app localizations
    //TODO get org localizations and merge here
    LocalizationsRef().doc(localizationKey).get().then(doc => {

      const appLocalizations = unwrapDoc(doc);

      if(!orgId){
        //sync w/ app localizations only
        dispatch({
          type: ACTIVATE_LOCALIZATION_SUCCESS,
          payload: appLocalizations,
        });

        callIfFunction(callback, appLocalizations);
      }
      else{
        //merge w/ org localizations
        OrgConfigRef().doc(orgId).collection('localizations').doc(localizationKey).get().then(doc => {
          const orgLocalizations = unwrapDoc(doc);

          const mergedLocalizations = {
            ...appLocalizations,
            ...orgLocalizations
          };

          dispatch({
            type: ACTIVATE_LOCALIZATION_SUCCESS,
            payload: mergedLocalizations,
          });

          callIfFunction(callback, mergedLocalizations);
        });
      }

      if(savePref){
        //Update user object to save this preference
        PublicUsersRef().doc(accountId()).update({
          preferredLanguage: localizationKey
        });
      }

    }).catch(err => logAndDispatchErrorForAction(`Fetch localization: ${localizationKey}`, err, dispatch, ACTIVATE_LOCALIZATION_ERROR));
  }
}

export function syncOrganizationExports(){
  return dispatch => {

    //get all teams in organization
    OrganizationExportsRef().onSnapshot(docs => {

      const exports = unwrapDocs(docs);

      dispatch({
        type: SYNC_EXPORTS,
        payload: exports,
      });
    });
  }
}

export function syncTeams(){

  return dispatch => {

    //get all teams in organization
    TeamsRef().onSnapshot(docs => {

      const teams = unwrapDocs(docs);

      dispatch({
        type: SYNC_TEAMS,
        payload: teams,
      });
    });
  }
}

function fetchTeamUsers(memberIds){
  const getUser = memberId => {
    return UsersRef().doc(memberId).get();
  }

  const userFetches = _.map(memberIds, memberId => {
    return getUser(memberId);
  });

  return Promise.all(userFetches);
}

function fetchTeamMembersCurrentSprints(memberIds){
  const getCurrentSprint = memberId => {
    return CurrentSprintsRef().doc(memberId).get();
  }

  const currentSprintFetches = _.map(memberIds, memberId => {
    return getCurrentSprint(memberId);
  });

  return Promise.all(currentSprintFetches);
}

function fetchTeamMembersTalentEvaluations(memberIds){
  const getTalentEvaluations = memberId => {
    return TalentEvaluationsRef().where("userId", "==", memberId).get().then(docs => {
      return unwrapDocs(docs);
    });
  }

  const talentEvaluations = _.map(memberIds, memberId => {
    return getTalentEvaluations(memberId);
  });

  return Promise.all(talentEvaluations);
}

function fetchTeamMembersPredictiveSkillsReviews(memberIds){
  const getPredictiveSkillsReviews = memberId => {
    return SalesCompetencyReviewsRef().where("seller", "==", memberId).get().then(docs => {
      return unwrapDocs(docs);
    });
  }

  const salesCompetencyReviews = _.map(memberIds, memberId => {
    return getPredictiveSkillsReviews(memberId);
  });

  return Promise.all(salesCompetencyReviews);
}

export function fetchUserData(userId, callback){
  UsersRef().doc(userId).get().then(userData => {
    callback(unwrapDoc(userData));
  });
}

export function fetchUserDataForTeam(team, callback){
  const cb = callback;

  (async() => {
    const teamData = await fetchTeamData(team);
    cb(teamData);
  })();
}

export function fetchUserDataForEveryone(callback, includeDeleted = false){
  //no action creator for now
  return dispatch => {
    UsersRef().get().then(allUserData => {
      callback(unwrapDocs(allUserData, includeDeleted));
    });
  }
}

async function fetchTeamData(team){
  console.log('fetchTeamData for :', team);

  const teamUsers = await fetchTeamUsers(team.members);
  const mappedTeamUsers = unwrapDocs(teamUsers);

  const teamLeaders = await fetchTeamUsers(team.leaders);
  const mappedTeamLeaders = unwrapDocs(teamLeaders);

  //console.log('mappedTeamUsers: ', mappedFirstTeamUsers);

  const teamSprints = await fetchTeamMembersCurrentSprints(team.members);
  const mappedTeamSprints = unwrapDocs(teamSprints);

  //console.log('mappedTeamSprints: ', mappedFirstTeamSprints);

  const teamTalentEvaluations = await fetchTeamMembersTalentEvaluations(team.members);
  const mappedTeamTalentEvaluations = _.union(...teamTalentEvaluations);

  const teamPredictiveSkillsReviews = await fetchTeamMembersPredictiveSkillsReviews(team.members);
  const mappedTeamPredictiveSkillsReviews = _.union(...teamPredictiveSkillsReviews);

  const organizationDoc = await OrganizationRef().get();
  const organization = unwrapDoc(organizationDoc);

  const { competenciesEnabled } = organization;

  //console.log('mappedTeamTalentEvaluations: ', mappedTeamTalentEvaluations);

  const teamData = {
    ...team,
    memberData: {},
    leaderData: {}
  };

  _.each(mappedTeamUsers, user => {

    const userId = user._id;

    let mappedUser = { ...user };

    //also add full name here for easy accessing
    mappedUser.name = mappedUser.firstName + ' ' + mappedUser.lastName;

    mappedUser.currentSprint = _.find(mappedTeamSprints, { _id: userId });
    mappedUser.talentEvaluations = _.filter(mappedTeamTalentEvaluations, { userId });
    mappedUser.salesCompetencyReviews = _.filter(mappedTeamPredictiveSkillsReviews, { seller: userId })

    mappedUser.managerSetup = {
      talentEvaluationOrPredictiveSkillsReviewComplete: competenciesEnabled ? (_.find(mappedUser.salesCompetencyReviews, predictiveSkillsReview => {
        return predictiveSkillsReview.reviewerStatus === 'complete';
      }) ? true : false) : (
        _.find(mappedUser.talentEvaluations, talentEvaluation => {
          return talentEvaluation.ratedBy === 'manager';
        }) ? true : false
      ),
      sprintSetup: mappedUser.currentSprint !== undefined,
      actionPlanDefined: actionPlanSetupForSprint(mappedUser.currentSprint),
      /*firstWeeklyReviewConductedForSprint: firstWeeklyReviewConductedForSprint(mappedUser.currentSprint)*/
    };

    mappedUser.managerSetupComplete =   mappedUser.managerSetup.talentEvaluationOrPredictiveSkillsReviewComplete &&
                                        mappedUser.managerSetup.sprintSetup &&
                                        mappedUser.managerSetup.actionPlanDefined;

    mappedUser.firstWeeklyReviewConductedForSprint = firstWeeklyReviewConductedForSprint(mappedUser.currentSprint);

    teamData.memberData[userId] = mappedUser;
  });

  _.each(mappedTeamLeaders, leader => {

    const leaderId = leader._id;

    let mappedLeader = { ...leader };

    //also add full name here for easy accessing
    mappedLeader.name = mappedLeader.firstName + ' ' + mappedLeader.lastName;

    teamData.leaderData[leaderId] = mappedLeader;
  });

  return teamData;
}

export function fetchMyTeams(managerId = accountId()){

  return async dispatch => {

    dispatch({ type: FETCH_TEAMS });

    try{

      const teams = await TeamsRef().where("leaders", "array-contains", managerId).get();

      const mappedTeams = unwrapDocs(teams);

      // console.log('found teams: ', mappedTeams);

      // if(!mappedTeams || mappedTeams.length === 0){
      //   console.log('NO TEAMS!? HOW DID THIS HAPPEN!?');
      // }

      let fetchAndMapTeamFunctions = _.map(mappedTeams, team => {
        return fetchTeamData(team);
      });

      const mappedTeamData = await Promise.all(fetchAndMapTeamFunctions);

      return dispatch({
        type: FETCH_TEAMS_SUCCESS,
        payload: mappedTeamData,
      });
    }
    catch(err){
      console.log('err fetching my teams: ', err);
      return dispatch({
        type: FETCH_TEAMS_ERROR,
        payload: err.message,
      });
    }
  }
}

export function fetchPublicUserDataForAssessmentOrganization(organizationId: string, callback){
  // console.log('fetching public users for org: ', organizationId);

  PublicUsersRef().where('currentAssessmentConfig.organization', '==', organizationId).get().then(docs => {
    // console.log('fetched public users: ', unwrapDocs(docs));
    callback(unwrapDocs(docs));
  });
}

export function syncEmployees(){

  return dispatch => {

    //get all users in organization
    UsersRef().where("organizationId", "==", organizationId()).onSnapshot(docs => {
      dispatch({
        type: SYNC_EMPLOYEES,
        payload: unwrapDocs(docs, true),//include deleted/archived employees
      });
    });
  }
}

export function syncOrganization(){
  return dispatch => {
    OrganizationRef().onSnapshot(doc => {
      // console.log('GOT ORGANIZATION!!!');
      // console.log(unwrapDoc(doc));
      dispatch({
        type: SYNC_ORGANIZATION,
        payload: unwrapDoc(doc)
      });
    });
  }
}

export function syncAssessmentConfgisForSuperAdmin(){
  return dispatch => {
    AssessmentConfigsRef().onSnapshot(docs => {
      dispatch({
        type: SYNC_ASSESSMENT_CONFIGS,
        payload: unwrapDocs(docs)
      });
    });
  }
}

export function syncOrganizationsForSuperAdmin(){
  return dispatch => {
    OrganizationsRef().onSnapshot(docs => {
      dispatch({
        type: SYNC_ORGANIZATIONS,
        payload: unwrapDocs(docs)
      });
    });
  }
}

export function syncAppConfig(){
  return dispatch => {
    AppConfigRef().onSnapshot(doc => {

      // console.log('new app config snapshot: ', doc);

      dispatch({
        type: SYNC_APP_CONFIG,
        payload: unwrapDoc(doc)
      });
    });
  }
}

export function fetchAssessmentConfig(assessmentName, callback){
  return dispatch => {
    AssessmentConfigsRef().doc(assessmentName).onSnapshot(doc => {

      const assessmentConfig = unwrapDoc(doc);

      // console.log('assessmentConfig: ', assessmentConfig);

      dispatch({
        type: FETCH_ASSESSMENT_CONFIG,
        payload: assessmentConfig
      });

      callIfFunction(callback, assessmentConfig);
    });
  }
}

export function fetchOrgConfig(orgId){
  return dispatch => {
    OrgConfigRef().doc(orgId).get().then(doc => {

      dispatch({
        type: FETCH_ORG_CONFIG,
        payload: unwrapDoc(doc)
      });
    });
  }
}

export function changeViewingOrganization(viewingOrganization){
  // console.log('should update viewing organization to be: ', viewingOrganization);

  return dispatch => {
    Firebase.firestore().collection('superadmins').doc(accountId()).update({
      viewingOrganization
    }).then(() => {
      dispatch(syncEmployees());
      dispatch(syncTeams());
      dispatch(syncOrganization());
    });
  }
}

function tryFetchingSuperadminData(uid, notSuperadminFunction, dispatch){
  Firebase.firestore().collection(`superadmins`).doc(uid).onSnapshot(doc => {
    if(!doc || !doc.data()){
      console.log('Not superadmin either!');
      console.log('cant find user!');
      notSuperadminFunction();
      return;
    }

    //load superadmin data
    scopeErrorReportingToUser(unwrapDoc(doc));
    scopeFullstoryCaptureToUser(unwrapDoc(doc));

    dispatch({
      type: SYNC_USER,
      payload: {
        ...unwrapDoc(doc),
        uid: doc.id
      }
    });

    // console.log('user is superadmin, fetching orgnization, employee, and team data');

    dispatch(syncOrganizationsForSuperAdmin());
    dispatch(syncAssessmentConfgisForSuperAdmin());
    dispatch(syncEmployees());
    dispatch(syncTeams());
    dispatch(syncOrganization());
    dispatch(syncLocalizations());
  });
}

export function syncUsersForExport(){
  return dispatch => {
    console.log('syncing users data for exporting reports...');

    PublicUsersRef().onSnapshot(docs => {
      dispatch({
        type: SYNC_USERS,
        payload: unwrapDocs(docs)
      });
      console.log('users data for export synced: ', unwrapDocs(docs));
    });
  }
}

export function updatePublicProfile(newUserInfo){

  //merge reference: https://firebase.google.com/docs/firestore/manage-data/add-data

  return dispatch => {
    PublicUsersRef().doc(accountId()).set({
      ...newUserInfo,
      lastModified: getCurrentTimestamp()
    },{ merge: true }).then(() => {
      PublicUsersRef().doc(accountId()).get().then(doc => {

        return dispatch({
          type: SYNC_USER,
          payload: {
            ...unwrapDoc(doc),
            uid: doc.id
          }
        });
      });
    });
  }
}

function setupNewPublicAssessmentUser(uid, dispatch){
  //create new user
  console.log('creating new user with pathname: ', window.location.pathname);

  //if assessment signup
  const splitPathname = window.location.pathname.split('/');
  if(userIsOnAssessmentPage()){

    const assessmentName = splitPathname[2];
    const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    const profileName = params.profile;

    AssessmentConfigsRef().doc(assessmentName).get().then(doc => {

      const assessmentConfig = unwrapDoc(doc);

      if(!assessmentConfig){
        alert('Invalid assessment login URL');
      }
      else{
        PublicUsersRef().doc(uid).set({
          currentAssessmentConfig: {
            assessmentName,
            profileName,
            organization: assessmentConfig.organization,
            ...(profileName && {profile: assessmentConfig.profileNames[profileName]}),
            ...(params.batchLabel && {batchLabel: params.batchLabel}),
            ...(params.grouping && {grouping: params.grouping})
          }
        });

        //resync user
        dispatch(syncUser())
      }
    });
  }
}

function setupOrganizationAssessmentUser(uid, dispatch){
  console.log('update organization user with pathname: ', window.location.pathname);

  //if assessment signup
  const splitPathname = window.location.pathname.split('/');
  if(userIsOnAssessmentPage()){

    const assessmentName = splitPathname[2];
    const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    const profileName = params.profile;

    AssessmentConfigsRef().doc(assessmentName).get().then(doc => {

      const assessmentConfig = unwrapDoc(doc);

      if(!assessmentConfig){
        alert('Invalid assessment login URL');
      }
      else{
        UsersRef().doc(uid).update({
          currentAssessmentConfig: {
            assessmentName,
            profileName,
            organization: assessmentConfig.organization,
            ...(profileName && {profile: assessmentConfig.profileNames[profileName]}),
            ...(params.batchLabel && {batchLabel: params.batchLabel}),
            ...(params.grouping && {grouping: params.grouping})
          }
        });

        //resync user
        dispatch(syncUser())
      }
    });
  }
}

function userIsOnAssessmentPage(){
  const splitPathname = window.location.pathname.split('/');
  if(splitPathname[1] === 'a' && splitPathname[2] && splitPathname[2] !== ''){
    return true;
  }

  return false;
}

export function syncUser(){

  console.log('syncing user...');

  return dispatch => {

    //EXPORT only - fetch all users in system
    //Deprecated - remove at some point
    if(isExport()){
      dispatch(syncUsersForExport());
    }

    Firebase.auth().onAuthStateChanged(auth => {

      console.log('Firebase Auth state changed to ', auth);

      //console.log('auth state changed - subscribing to changes & reloading EVERYTHING');
      if(!auth){
        dispatch({
          type: SYNC_USER,
          payload: false
        });
      }
      else{

        //sync app config asap
        dispatch(syncAppConfig());

        //console.log('new auth email: ', auth.email);
        const {uid, email, emailVerified, displayName, photoUrl} = auth;

        PublicUsersRef().doc(uid).get().then(doc => {

          //could not find user
          if(!doc || !doc.data()){
            // console.log('Could not find user data for account - check if superadmin, if not setup as new assessment user');

            return tryFetchingSuperadminData(uid, () => {
              setupNewPublicAssessmentUser(uid, dispatch);
            }, dispatch);
          }

          const preferredLanguage = doc.data().preferredLanguage;
          const orgId = doc.data().organization;
          const assessmentOrgId = (doc.data().currentAssessmentConfig || {}).organization;

          //load preferred language if exists
          if(preferredLanguage){
            dispatch(activateLocalization(preferredLanguage, orgId || assessmentOrgId));
          }
          else{
            dispatch(activateLocalization('en', orgId || assessmentOrgId));
          }

          //Public profile for assessments
          //keep user data synced with public profile
          if(!orgId){

            const pathname = window.location.pathname;

            //user is on traditional login page - redirect to assessment
            if(pathname === '/login'){
              // console.log('pathname === login for NON organization-linked account - redirecting to assessments');
              window.location.href = appConfig().APP_URL + '/a';
              return;
            }

            return dispatch({
              type: SYNC_USER,
              payload: {
                ...unwrapDoc(doc),
                uid: doc.id
              }
            });
          }

          //get user data
          Firebase.firestore().collection(`organizations/${orgId}/users`).doc(uid).onSnapshot(doc => {

            //need access to role to determine what needs to be synced on load
            const {
              role,
              currentAssessmentConfig,
            } = doc.data();

            scopeErrorReportingToUser(unwrapDoc(doc));
            scopeFullstoryCaptureToUser(unwrapDoc(doc));

            //if on assessment page, but no assessment config setup, do that now
            if(userIsOnAssessmentPage() && !currentAssessmentConfig){
              //will dispatch sync again once assessment config setup
              return setupOrganizationAssessmentUser(uid, dispatch);
            }

            dispatch({
              type: SYNC_USER,
              payload: {
                ...unwrapDoc(doc),
                ...(preferredLanguage && { preferredLanguage }),
                uid: doc.id
              }
            });

            //if admin or manager, get all employee data
            //eventually will limit this to specific pages
            //and/or employees that are part of a manager's team
            if(role === 'admin' || role === 'salesleader'){
              dispatch(syncEmployees());
              dispatch(syncTeams());

              if(role === 'salesleader'){
                dispatch(fetchMyTeams(uid));
              }
            }

            if(role === 'manager'){
              //TODO figure out if all employees are needed
              dispatch(syncEmployees());

              //TODO figure out if this is needed - for now I think we need it
              //for team links to work correctly
              //Note this also gives managers access to all team data
              //1/30/19 - removing for now as managers shouldn't have permission to view this.
              //if anyone needs to view this, I'm going to make them a sales leader instead so they can view other team data.
              //dispatch(syncTeams());

              dispatch(fetchMyTeams(uid));
            }

            //for useres w/ ability to access exports, sync exports
            if(role === 'assessmentadmin' || role === 'admin'){
              dispatch(syncOrganizationExports());
            }

            //all
            dispatch(syncOrganization());
          });

        });
      }
    }, error => {
      console.error('Error retrieving auth state update: ', error);
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js